"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewFile extends new_item_1.default {
    constructor(newFile) {
        super();
        this.itemType = newFile.itemType;
        this.itemId = newFile.itemId;
        this.name = newFile.name;
        this.type = newFile.type;
        this.size = newFile.size;
        this.file = newFile.file;
        this.ref = newFile.ref;
        this.description = newFile.description;
        this.location = newFile.location;
        this.thumbnail = newFile.thumbnail;
        this.uploadRef = newFile.uploadRef;
        this.uploadedByName = newFile.uploadedByName;
        this.ORN = newFile.ORN;
        this.uploadedStamp = newFile.uploadedStamp;
    }
}
exports.default = NewFile;
//# sourceMappingURL=new-file.js.map